import { createI18n, I18nProvider, type Resource, withApiErrorMessages } from '@jq4race/i18n';
import type { ReactNode } from 'react';

const en = import.meta.glob('./locales/en/*.json', { eager: true, import: 'default' });
const es = import.meta.glob('./locales/es/*.json', { eager: true, import: 'default' });

function nsFromPath(p: string): string {
  return p.slice(p.lastIndexOf('/') + 1).replace(/\.json$/, '');
}
function buildLang(mods: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [p, mod] of Object.entries(mods)) out[nsFromPath(p)] = mod;
  return out;
}

// `apiErrors` = shared backend-error copy (api-client) + this app's own keys.
const resources: Resource = {
  en: withApiErrorMessages('en', buildLang(en)),
  es: withApiErrorMessages('es', buildLang(es)),
} as Resource;
const namespaces = Object.keys(resources.en as object);

export const i18n = createI18n({
  resources,
  ns: namespaces,
  defaultNS: 'common',
});

export function AppI18nProvider({ children }: { children: ReactNode }) {
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
